import type { ComponentProps, PropsWithChildren } from 'react';
import { useId } from 'react';

import { Link } from '#components/Link/Link';
import { IconSystem } from '#icons/IconSystem';
import type { IconVariantMap } from '#icons/icons-system';

import type { IconButtonProps } from './IconButton';
import styles from './IconSystemLink.module.scss';

type Props<IconName extends keyof IconVariantMap = keyof IconVariantMap> = IconButtonProps<IconName> & ComponentProps<typeof Link>;

export function IconSystemLink<IconName extends keyof IconVariantMap>({
	type,
	icon,
	variant,
	className = '',
	children,
	size = 'm',
	...linkProperties
}: PropsWithChildren<Props<IconName>>) {
	const id = `isl-${useId()}`;

	return (
		<Link id={id} className={`${styles.link} ${styles[type]} ${styles[size]} ${className} no-focus no-hover`} {...linkProperties}>
			<IconSystem icon={icon} variant={variant} size="m" className={styles.icon} aria-labelledby={id} />
			{children}
		</Link>
	);
}
